<template>
    <div class="container">
        <div class="apprentice-simple-card">
            <design2021-cl4l-life-skills-assessment-2024-08-27-component
                v-if="testResponse.test_issuing.test.key === 'cl4l-life-skills-assessment-2024-08-27'"
                :result-data="testResponse.result_data">
            </design2021-cl4l-life-skills-assessment-2024-08-27-component>

            <design-2021-job-personality-mbo-occupation-test-2024-05-16-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-mbo-occupation-test-2024-05-16'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-mbo-occupation-test-2024-05-16-component>

            <design-2021-job-personality-personality-test-2024-05-16-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-personality-test-2024-05-16'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-personality-test-2024-05-16-component>

            <design-2021-job-personality-study-choice-test-2024-05-16-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-study-choice-test-2024-05-16'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-study-choice-test-2024-05-16-component>

            <design-2021-job-personality-profile-choice-test-2024-06-12-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-profile-choice-test-2024-06-12'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-profile-choice-test-2024-06-12-component>

            <design2021-lobx-job-event-test2024-12-19-component
                v-if="testResponse.test_issuing.test.key === 'lobx-job-event-test-2024-12-19'"
                :result-data="testResponse.result_data">
            </design2021-lobx-job-event-test2024-12-19-component>

            <design-2021-example-test-component
                v-if="testResponse.test_issuing.test.key === 'example-test'"
                :result-data="testResponse.result_data">
            </design-2021-example-test-component>

            <design-2021-job-personality-culture-type-test-2024-12-16-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-cultural-type-test-2024-12-16'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-culture-type-test-2024-12-16-component>

            <design-2021-job-personality-cultural-interest-test-2024-12-17-component
                v-if="testResponse.test_issuing.test.key === 'job-personality-cultural-interest-test-2024-12-17'"
                :result-data="testResponse.result_data">
            </design-2021-job-personality-cultural-interest-test-2024-12-17-component>
        </div>
    </div>
</template>

<script>
import Design2021Cl4lLifeSkillsAssessment20240827Component from './result/design-2021-cl4l-life-skills-assessment-2024-08-27-component.vue';
import Design2021ExampleTestComponent from './result/design-2021-example-test-component.vue';
import Design2021JobPersonalityCultureTypeTest20241216Component from './result/design-2021-job-personality-culture-type-test-2024-12-16-component.vue';
import Design2021JobPersonalityMboOccupationTest20240516Component from './result/design-2021-job-personality-mbo-occupation-test-2024-05-16-component.vue';
import Design2021JobPersonalityPersonalityTest20240516Component from './result/design-2021-job-personality-personality-test-2024-05-16-component.vue';
import Design2021JobPersonalityProfileChoiceTest20240612Component from './result/design-2021-job-personality-profile-choice-test-2024-06-12-component.vue';
import Design2021JobPersonalityStudyChoiceTest20240516Component from './result/design-2021-job-personality-study-choice-test-2024-05-16-component.vue';
import Design2021LobxJobEventTest20241219Component from './result/design-2021-lobx-job-event-test-2024-12-19-component.vue';
import Design2021JobPersonalityCulturalInterestTest20241217Component from './result/design-2021-job-personality-cultural-interest-test-2024-12-17-component.vue';

export default {
    name: 'design-2021-show-test-result-component',
    props: {
        testResponseIn: {
            type: Object,
            required: true,
        },
    },

    components: {
        Design2021Cl4lLifeSkillsAssessment20240827Component,
        Design2021ExampleTestComponent,
        Design2021JobPersonalityCultureTypeTest20241216Component,
        Design2021JobPersonalityMboOccupationTest20240516Component,
        Design2021JobPersonalityPersonalityTest20240516Component,
        Design2021JobPersonalityProfileChoiceTest20240612Component,
        Design2021JobPersonalityStudyChoiceTest20240516Component,
        Design2021LobxJobEventTest20241219Component,
        Design2021JobPersonalityCulturalInterestTest20241217Component,
    },

    data() {
        return {
            testResponse: this.testResponseIn,
        };
    },
};
</script>

<style scoped lang="scss"></style>
